export default __webpack_public_path__ + "static/media/johnny.7c823bd4.png";